import PropTypes from 'prop-types';
import { useState } from 'react';
import { useUser } from 'Components/Organisms/UserProvider/useUser';
import ChangeWorkspaceSelectProjectDialog from './ChangeWorkspaceSelectProjectDialog';
import ChangeWorkspaceSelectedDialog from './ChangeWorkspaceSelectedDialog';

export default function ChangeWorkspaceDialog(props) {
    const { open, onClose } = props;
    const [showWorkspaces, setShowWorkspaces] = useState(false);
    const [projectSelected, setProjectSelected] = useState(null);
    const { user } = useUser();

    const isOwner = projectSelected?.users?.find((u) => u.user_id === user.id)?.role === 'owner';

    const handleClose = () => {
        setShowWorkspaces(false);
        onClose();
    };

    return (
        <>
            <ChangeWorkspaceSelectProjectDialog
                open={open && !showWorkspaces}
                onClose={handleClose}
                onSelect={(projectSelected) => {
                    setShowWorkspaces(true);
                    setProjectSelected(projectSelected);
                }}
            />

            <ChangeWorkspaceSelectedDialog
                projectId={projectSelected?.id}
                name={projectSelected?.name}
                open={open && showWorkspaces}
                isOwner={isOwner}
                onClose={handleClose}
                onBack={() => {
                    setShowWorkspaces(false);
                    setProjectSelected(null);
                }}
            />
        </>
    );
}

ChangeWorkspaceDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};
